import styles from "./Sidebar.module.css";

const SidebarSection = ({ title, isCollapsed }) => {
  if (isCollapsed) {
    return <div className={styles.sectionHeaderCollapsed} aria-hidden="true" />;
  }

  return (
    <div className={styles.sectionHeader}>
      <span>{title}</span>
    </div>
  );
};

export default SidebarSection;
